import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row, Card, Typography } from '../../ui/ot'
import defaultBlogTypeData from './blog_type_data';
import useBlogMedia from './use_blog_media'; // 引入自定義 hook


const Video = (
    {
        blogTypeData = defaultBlogTypeData
    }
) => {

    const navigate = useNavigate();
    const {
        files,
        get_picture,
        toLinkSomewhere,
        isMoreContentEmpty,
        renderMediaContent,
    } = useBlogMedia(blogTypeData); // 使用自定義 hook
    const contentStyle = {
        height: '20vh',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',

    };
    const sliderSetting = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
    };


    return (
        <Row gutter={[8, 8]} style={{ padding: "1rem" }}>
            {blogTypeData?.map((blogTypeData) => {
                return (
                    <>
                        {!Boolean(blogTypeData.blog_type_hidden_name) && (
                            <Col span={24} style={{ textAlign: "center", position: "relative" }}>
                                {/* 主標題 */}
                                <Typography.Title level={2}
                                    style={{
                                        fontWeight: "700",
                                        background: "linear-gradient(90deg, #fa8c16, #ff4d4f)", // 漸層色
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent", // 文字漸層
                                        margin: "0",
                                        lineHeight: "1.2",
                                        padding: "0 20px",
                                        borderBottomWidth: 0
                                    }}>
                                    {blogTypeData?.blog_type_name}
                                </Typography.Title>

                                {/* 分隔線 */}
                                <div
                                    style={{
                                        width: "100px",
                                        height: "6px",
                                        background: "linear-gradient(90deg, #fa8c16, #ff4d4f)", // 漸層色
                                        margin: "10px auto",
                                        borderRadius: "3px",
                                        animation: "pulse 2s infinite",
                                    }}
                                ></div>
                            </Col>
                        )
                        }
                        {
                            blogTypeData?.frontend_column_frontend_component_blog_type_blog_data.map((blogData, blogIndex) => {
                                let file = blogData?.blog_type_classify_structure_type_blog_data
                                let file_id = file?.find(_ => true)?.file_id
                                return (
                                    <Col
                                        lg={8}
                                        md={12}
                                        sm={12}
                                        xs={24}
                                    >
                                        <Card>
                                            <Row gutter={[8, 8]} style={{ height: '40vh' }}>
                                                <Col span={24}>
                                                    {renderMediaContent(blogData?.youtube_iframe, file, sliderSetting, contentStyle)
                                                    }
                                                </Col>
                                                <Col span={24}>
                                                    標題：{blogData?.title}
                                                </Col>
                                                <Col span={24}>
                                                    說明：{blogData?.content}
                                                </Col>
                                                {
                                                    blogData?.more_content &&
                                                    !isMoreContentEmpty(blogData.more_content) &&
                                                    <Col span={24}
                                                        style={{
                                                            textAlign: "right"
                                                        }}
                                                    >
                                                        <Button
                                                            size={"small"}
                                                            onClick={e => navigate(`/officialweb/frontend/moreContent/${blogData.blog_id}`)}
                                                        >
                                                            詳細內容
                                                        </Button>
                                                    </Col>
                                                }
                                            </Row>
                                        </Card>
                                    </Col>

                                )
                            })
                        }
                    </>
                )
            })}
        </Row>

    )
}

export default Video;